// extracted by mini-css-extract-plugin
export default {"SiteLightBlue":"#0B7EB5","Main":"Tooltip_Main__Asjq3","Icon":"Tooltip_Icon__iBYmL"};